import BillingPage from './BillingPage';

export default BillingPage;
